import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {EaProjectDto} from "../../../../../model/dto/entity/ea-project.dto";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {EaAnalysisResultService} from "../../../../../service/api/ea-analysis-result.service";
import {ObjectRequestList} from "../../../../../../../core/shared/dto/object/request/object-request-list";
import {PagingDto} from "../../../../../../../core/shared/dto/model/paging.dto";

@Component({
    selector: 'ea-project-overview-tab',
    templateUrl: './ea-project-overview-tab.component.html',
    standalone: false
})
export class EaProjectOverviewTabComponent implements OnInit, OnChanges, OnDestroy {

    @Input() objectIdentifier: ObjectIdentifier;
    @Input() dto: EaProjectDto;

    initialized: boolean;
    projectDataWidget: WidgetData;
    recentFilesWidget: WidgetData;
    recentAnalysisWidget: WidgetData;
    latestAnalysisResultId: number;

    constructor(
        protected analysisResultService: EaAnalysisResultService
    ) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent(): void {
        this.refreshWidgets();
        this.loadLatestAnalysisResult();
        this.initialized = true;
    }

    loadLatestAnalysisResult(): void {
        if (!this.objectIdentifier?.objectId) {
            return;
        }
        const filter = FilterCriteria.create('sourceFile.project', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        const request = ObjectRequestList.createWithPaging(false, [filter], [], PagingDto.create(0, 1));
        this.analysisResultService.list(request).subscribe({
            next: (result) => {
                if (result?.entries?.length > 0) {
                    this.latestAnalysisResultId = result.entries[0].id;
                }
            }
        });
    }

    refreshWidgets(): void {
        if (!this.objectIdentifier?.objectId) {
            return;
        }

        this.projectDataWidget = WidgetFactory.createWidgetEntityData(
            'ea.project.data.widget',
            'Project Details',
            'ea.EaProject',
            this.objectIdentifier.objectId
        );

        const fileFilter = FilterCriteria.create('project', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        this.recentFilesWidget = WidgetFactory.createWidgetTableEntityBasicQl(
            'ea.project.recent.files.widget',
            'Recent Files',
            'ea.EaSourceFile',
            [fileFilter]
        );

        const analysisFilter = FilterCriteria.create('sourceFile.project', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        this.recentAnalysisWidget = WidgetFactory.createWidgetTableEntityBasicQl(
            'ea.project.recent.analysis.widget',
            'Recent Analysis',
            'ea.EaAnalysisResult',
            [analysisFilter]
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['objectIdentifier'] || changes['dto']) {
            this.refreshWidgets();
        }
    }

    ngOnDestroy(): void {
    }
}
